import { transmissionAction } from "app/store/transmission/actions/transmissionAction";
import { clinicNoteState } from "app/store/transmission/slice//state/clinicNoteState";
import { patientNoteState } from "app/store/transmission/slice//state/patientNoteState";
import { previousAlertState } from "app/store/transmission/slice//state/previousAlertState";
import { reportBillingState } from "app/store/transmission/slice//state/reportBillingState";
import { reportDetailModalState } from "app/store/transmission/slice/state/reportDetailModalState";
import { transmissionCountState } from "app/store/transmission/slice/state/transmissionCountState";
import { transmissionModalState } from "app/store/transmission/slice/state/transmissionModalState";
import { transmissionPatientModalState } from "app/store/transmission/slice/state/transmissionPatientModalState";
import { transmissionPdfState } from "app/store/transmission/slice/state/transmissionPdfState";
import { transmissionTableState } from "app/store/transmission/slice/state/transmissionTableState";
import { transmissionTaskState } from "app/store/transmission/slice/state/transmissionTaskState";
import { transmissionToggleState } from "app/store/transmission/slice/state/transmissionToggleState";
import { CURRENT_YEAR } from "static/constants";
import { insertPageState } from "./state/insertPage";

import { reportNoteState } from "./state/reportNoteState";
import { ehrNoteState } from "./state/ehrNoteState";

import { createSlice } from "@reduxjs/toolkit";
import { providerNoteState } from "./state/providerNoteState";

export const transmissionInitialState = {
  title: "",
  route: "",
  selectedTab: "",
  reports: [],
  reportList: [],
  reportsMeta: {},
  isLoading: false,
  year: CURRENT_YEAR,
  anticoagStatus: "all",
  anticoagInformation: null,
  isUpdatingReportNotes: false,
  ...transmissionCountState,
  ...transmissionModalState,
  ...transmissionPatientModalState,
  ...transmissionTableState,
  ...transmissionToggleState,
  ...reportDetailModalState,
  ...patientNoteState,
  ...clinicNoteState,
  ...reportBillingState,
  ...transmissionPdfState,
  ...transmissionTaskState,
  ...previousAlertState,
  ...reportNoteState,
  ...insertPageState,
  ...ehrNoteState,
  ...providerNoteState,
};

const transmissionSlice = createSlice({
  name: "transmission",
  initialState: transmissionInitialState,
  reducers: transmissionAction,
});

export const {
  setTitle,
  setRoute,
  changePage,
  changeTab,
  setSelectedTab,
  changePageSize,
  changeSelectedRows,
  toggleFilter,
  togglePatientAlert,
  toggleDeviceAlert,
  toggleReportType,
  toggleAlert,
  toggleBilledFilter,
  toggleMyPatients,
  clearMyPatients,
  changeSearch,
  changePhysiciansFilter,
  toggleModal,
  toggleProcessing,
  toggleReportSigning,
  toggleReportProcessing,
  toggleSignAndProcessing,
  changeNextSendDate,
  changeNextSendInformation,
  updateNextBillingDateChangedStatus,
  selectedPhysicians,
  changePatient,
  changePatientTab,
  setLoading,
  changeCount,
  setReports,
  setReportsMeta,
  selectedReport,
  toggleDrawer,
  setCurrentPatientNote,
  changeExpansion,
  onPatientNotesChange,
  onPatientNotesFocus,
  cancelPatientNotes,
  changeBillableDate,
  changeOriginalBillableDate,
  toggleBillingDate,
  toggleNurseFlag,
  toggleClinicEsig,
  clinicNoteSubmitting,
  onChangeClinicNotes,
  setClinicNotesTouched,
  resetClinicNotes,
  onReportFINChange,
  onSpeechRecognizing,
  onClinicEsigChange,
  onClinicMrnChange,
  toggleSubmitting,
  toggleAlertStatus,
  toggleAnticoagStatus,
  toggleAnticoagInformation,
  toggleIsUpdatingReportNotes,
  toggleAttentionStatus,
  loadPatientNotes,
  setPdfPages,
  setPreviousReportPdfPages,
  pageLoadSuccess,
  setCurrentPage,
  editPatientNote,
  setCurrentReportTask,
  loadReportTaskList,
  onReportTaskInputFocus,
  cancelReportTask,
  editReportTask,
  loadPatient,
  changeProfileField,
  setBillingEqual,
  loadPatientReports,
  setAlertFilter,
  setDateFilter,
  resetAlertFilters,
  setPreviousReport,
  setPdfFileName,
  setTransmissionReportPdf,
  setTransmissionReportPdfUrl,
  setIsTransmissionReportModified,
  setPreviousReportPdfUrl,
  loadReports,
  getReportNotes,
  setSeverityIndex,
  setPdfPageRefs,
  setReportNoteEditable,
  setReportNoteEditAccess,
  setReportNotesTouched,
  setExplicitReportNoteEditable,
  setReportNote,
  setFieldValue,
  addNote,
  removeNote,
  toggleUndo,
  setReportList,
  setSelectedAlert,
  toggleFetchTableData,
  setCacheRefresh,
  updatePatientProfileInformation,
  yearlyTableFilter,
  setPatientCurrentTask,
  setFetchPatientTasks,
  changeAntiCoagStatus,
  changeProfileTab,
  setScrollToNotesSection,
  setAccessToProfileTabs,
  toggleReportAlertBanner,
  toggleDataPointMode,
  setFetchPatientReports,
  setReportAccountDetail,
  setShowEditDiagnosisModal,
  setBillingDiagnosisCodes,
  setShowActionMenu,
  setFileToAttachToReport,
  setOriginalFileToAttachToReport,
  setFileToAttachSelected,
  toggleTransmissionType,
  setUpdatedTransmissionReportFile,
  setReportCurrentTab,
  setTransmissionReportFileEnableCache,
  toggleArchiving,
  resetOriginalProfile,
  setAutoScrollPageNumber,
  setEvokeReportNotes,
  setOriginalEvokeReportNotes,
  setCurrentEHRNote,
  loadEHRNoteList,
  onEHRNoteChange,
  onEHRNoteInputFocus,
  cancelEHRNote,
  resetEHRNotes,
  setCanEditEHRNote,
  setMaximumAlertPriority,
  setAlertNotificationConfigs,
  setSaveWithProcess,
  setReportInterval,
  setUseReportIntervalFilter,
  setIsFetchingCoverPage,
  setCoverPageLength,
  toggleDeactivate,
  setShowSuggestionModal,
  setReportNoteSuggestions,
  togglePriorityType,
  resetTransmissionState,
  toggleSavedReports,
  setInvalidBillingDateResponse,
  toggleHasAlertBanner,
  setBenchmarkPatientInsurances,
  setCrossFacilityReport,
  toggleNonBillable,
  toggleAuditedReports,
  toggleMissingPatientDetailModal,
  onChangeProviderNotes,
  setProviderNotesTouched,
  onProviderEsigChange,
  onProviderMrnChange,
  resetProviderNotes,
  setSelectedRow,
  setPhoneOptOutInformation,
  setInitialPatientNotes,
  setUpdatedPatientNotes,
} = transmissionSlice.actions;

export default transmissionSlice.reducer;
